import { request } from '@umijs/max';

const listGames = async () => {
  return request<API.GameApplication[]>('/list-items/app', {
    method: 'GET',
    params: {},
  });
};

async function listFirebaseProjects() {
  return request('/list-items/firebase-projects', {
    method: 'GET',
    params: {},
  });
}

async function getGame(appId: string) {
  return request('/get-item', {
    method: 'GET',
    params: {
      id: appId,
      type: 'App',
    },
  });
}

async function createGame(data: any) {
  return request('/create-item/app', {
    method: 'POST',
    data,
  });
}

async function updateGame(id: string, data: any) {
  return request(`/update-item/app`, {
    method: 'POST',
    data: {
      appId: id,
      ...data,
    },
  });
}

async function deleteGame(id: string) {
  return request(`/delete-item/app`, {
    method: 'POST',
    data: {
      appId: id,
    },
  });
}

async function refreshGame(id: string, projectId: string) {
  return request(`/misc/update-app-icon`, {
    method: 'POST',
    data: {
      appId: id,
      projectId,
    },
  });
}

export {
  listGames,
  listFirebaseProjects,
  getGame,
  createGame,
  updateGame,
  deleteGame,
  refreshGame,
};
